import { DeliveryPointSchedule } from '../types/delivery-point.type';
import { STORABLE_DAYS, StorableDay } from '../types/delivery-point-day.type';

const DAY_ABBREVIATIONS: Record<string, string> = {
  monday: 'Lun',
  tuesday: 'Mar',
  wednesday: 'Mer',
  thursday: 'Jeu',
  friday: 'Ven',
  saturday: 'Sam',
  sunday: 'Dim',
};

const STORABLE_DAY_LABELS: Record<StorableDay, string> = {
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
};

// Dérivée de `STORABLE_DAYS`, la seule source des jours stockables : dimanche reste absent ici
// puisque la collection ne sait pas le stocker et que l'API le rejette à l'écriture.
export const STORABLE_DAY_OPTIONS = STORABLE_DAYS.map((day) => ({
  value: day,
  label: STORABLE_DAY_LABELS[day],
}));

export function formatScheduleDays(schedules: DeliveryPointSchedule[]): string {
  return schedules
    .map((schedule) => DAY_ABBREVIATIONS[schedule.day])
    .filter((dayAbbreviation): dayAbbreviation is string => !!dayAbbreviation)
    .join(', ');
}

export function formatScheduleLines(schedules: DeliveryPointSchedule[]): string[] {
  return schedules
    .filter((schedule) => !!DAY_ABBREVIATIONS[schedule.day])
    .map((schedule) => {
      const pickupLine = `${DAY_ABBREVIATIONS[schedule.day]} ${schedule.pickup.from} - ${schedule.pickup.to}`;
      return schedule.deposit ? `${pickupLine} (dépôt ${schedule.deposit.from} - ${schedule.deposit.to})` : pickupLine;
    });
}
